/**
 * Constants
 * Layout-related constants for Quick Sale screen
 */

/**
 * Layout constants for grid system and spacing
 */
export const LAYOUT = {
  /** AppBar height in pixels */
  APPBAR_HEIGHT: 64,
  
  /** Grid layout configuration */
  GRID: {
    /** Cart section (left side) */
    CART_SECTION: {
      XS: 5,
      MIN_WIDTH: 320,
    },
    /** Product section (right side) */
    PRODUCT_SECTION: {
      XS: 7,
      MIN_WIDTH: 560,
    },
    /** Action controls panel minimum width */
    ACTION_CONTROLS_MIN_WIDTH: 260,
    /** Product display area minimum width */
    PRODUCT_DISPLAY_MIN_WIDTH: 300,
  },
  
  /** Timeout constants in milliseconds */
  TIMEOUTS: {
    /** Delay before showing modal after payment completion */
    MODAL_DELAY: 500,
    /** Delay before focusing search input after modal close */
    FOCUS_DELAY: 100,
    /** Delay before refreshing image cache */
    IMAGE_CACHE_REFRESH: 1000,
  },
} as const;

